import React, { useState, useMemo, useEffect } from 'react';
import {
  Dropdown,
  Header,
  Icon,
  List,
  Pagination,
  Segment,
  Statistic,
} from 'semantic-ui-react';
import dayjs from 'dayjs';

import {
  CustomContainer,
} from '../../common';
import {
  ArticleLink,
  UserLink,
} from '../../Links';
import {
  formatDatetime,
} from '../../Utils';

const STYLES = {
  DROPDOWN: {
    float: 'right',
    cursor: 'pointer',
    color: '#7f8c8d',
  },
};
// since semantic-ui doesn't support function type in Dropdown value, we have to use string
const SORT_STRATEGIES_TYPE = {
  HOTTEST: 'hottest',
  LATEST: 'latest',
  EARLIEST: 'earliest',
};
const SORT_STRATEGIES = {
  [SORT_STRATEGIES_TYPE.HOTTEST]: (a, b) => b.num_pushes - a.num_pushes,
  [SORT_STRATEGIES_TYPE.LATEST]: (a, b) => dayjs(a.datetime).isAfter(dayjs(b.datetime)) ? -1 : 1,
  [SORT_STRATEGIES_TYPE.EARLIEST]: (a, b) => dayjs(a.datetime).isBefore(dayjs(b.datetime)) ? -1 : 1,
};
const SORT_BY_DROPDOWN_OPTIONS = [
  {
    key: 'hot',
    text: '關注度',
    value: SORT_STRATEGIES_TYPE.HOTTEST,
    content: '關注度',
  },
  {
    key: 'new',
    text: '最新',
    value: SORT_STRATEGIES_TYPE.LATEST,
    content: '最新',
  },
  {
    key: 'old',
    text: '最舊',
    value: SORT_STRATEGIES_TYPE.EARLIEST,
    content: '最舊',
  },
];

export default ({ data, loading, isMobile }) => {
  if (!loading && (!Array.isArray(data.replies) || !data.replies.length)) {
    return (null);
  }

  const [activePage, setActivePage] = useState(1);
  const [sortBy, setSortBy] = useState(SORT_STRATEGIES_TYPE.HOTTEST);

  const totalPages = useMemo(
    () => Array.isArray(data.replies) && data.replies && Math.ceil(data.replies.length / 10),
    [data.replies],
  );

  const replies = useMemo(
    () => Array.isArray(data.replies) && data.replies
      .sort(SORT_STRATEGIES[sortBy])
      .slice((activePage - 1) * 10, activePage * 10),
    [data.replies, sortBy, activePage],
  );

  useEffect(() => {
    setActivePage(1);
  }, [sortBy])

  return (
    <CustomContainer>
      <Header
        as={isMobile ? 'h3' : 'h2'}
        attached="top"
      >
        相關回文 ({data.replies.length})
        <div
          style={STYLES.DROPDOWN}
        >
          <Dropdown
            inline
            options={SORT_BY_DROPDOWN_OPTIONS}
            defaultValue={sortBy}
            onChange={(e, { value }) => { setSortBy(value) }}
          />
        </div>
      </Header>
      <Segment attached loading={loading}>
        <List
          divided
          relaxed
          size={isMobile ? 'small' : 'large'}
        >
          {
            replies.map((article) => (
              <List.Item
                key={article.id}
              >
                <List.Content floated="right">
                  <Statistic
                    size={isMobile ? 'mini' : 'tiny'}
                  >
                    <Statistic.Value>
                      {article.num_pushes}
                    </Statistic.Value>
                    <Statistic.Label>
                      關注度
                      <Icon name="thumbs outline up" color="blue" size="small" />
                      <Icon name="thumbs outline down" color="red" size="small" />
                      <Icon name="arrow right" color="yellow" size="small" />
                    </Statistic.Label>
                  </Statistic>
                </List.Content>
                <List.Content>
                  <List.Header>
                    <ArticleLink id={article.id}>
                      {article.title}
                    </ArticleLink>
                  </List.Header>
                  <List.Description>
                    <UserLink id={article.author_id}>
                      {article.author_id}
                    </UserLink>
                    @
                    {' '}
                    {formatDatetime(article.datetime)}
                  </List.Description>
                </List.Content>
              </List.Item>
            ))
          }
        </List>
        {
          totalPages > 1 && (
            <Pagination
              boundaryRange={isMobile ? 0 : 3}
              ellipsisItem={isMobile ? null : '...'}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              totalPages={totalPages}
              activePage={activePage}
              onPageChange={(e, { activePage }) => { setActivePage(activePage); }}
            />
          )
        }
      </Segment>
    </CustomContainer>
  );
};
